module.exports = __webpack_public_path__ + "static/img/rank_40.640b339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_40.png
// module id = OVFp
// module chunks = 1